import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=b16b12fa&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.vue?vue&type=style&index=0&id=b16b12fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16b12fa",
  null
  
)

export default component.exports